<template>
  <main class="privacy-page" :class="localeClass">
    <section ref="privacyBlockRef" class="privacy-block">
      <div class="text-wrap">
        <h1>{{ $t('privacy.pageTitle') }}</h1>
        <ul>
          <li>
            <a href="#privacy1" @click.prevent="scrollToTarget('#privacy1')">{{ $t('privacy.toc1') }}</a>
          </li>
          <li>
            <a href="#privacy2" @click.prevent="scrollToTarget('#privacy2')">{{ $t('privacy.toc2') }}</a>
          </li>
          <li>
            <a href="#privacy3" @click.prevent="scrollToTarget('#privacy3')">{{ $t('privacy.toc3') }}</a>
          </li>
          <li>
            <a href="#privacy4" @click.prevent="scrollToTarget('#privacy4')">{{ $t('privacy.toc4') }}</a>
          </li>
          <li>
            <a href="#privacy5" @click.prevent="scrollToTarget('#privacy5')">{{ $t('privacy.toc5') }}</a>
          </li>
          <li>
            <a href="#privacy6" @click.prevent="scrollToTarget('#privacy6')">{{ $t('privacy.toc6') }}</a>
          </li>
          <li>
            <a href="#privacy7" @click.prevent="scrollToTarget('#privacy7')">{{ $t('privacy.toc7') }}</a>
          </li>
          <li>
            <a href="#privacy8" @click.prevent="scrollToTarget('#privacy8')">{{ $t('privacy.toc8') }}</a>
          </li>
        </ul>
      </div>
    </section>

    <section class="privacy-content" data-aos="fade">
      <div class="row row-center">
        <div class="col-12-sm col-8">
          <p class="privacy-answer">{{ formatServiceMessage('privacy.intro') }}</p>

          <h4 id="privacy1">{{ $t('privacy.section1Title') }}</h4>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section1Intro') }}</p>
          <h5>{{ $t('privacy.section1PurposeTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section1PurposeText') }}</p>
          <h5>{{ $t('privacy.section1DataTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section1DataText') }}</p>
          <h5>{{ $t('privacy.section1OptionalTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section1OptionalText') }}</p>

          <h4 id="privacy2">{{ $t('privacy.section2Title') }}</h4>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section2Intro') }}</p>
          <h5>{{ $t('privacy.section2IdentityTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section2IdentityText') }}</p>
          <h5>{{ $t('privacy.section2RecommendationTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section2RecommendationText') }}</p>
          <h5>{{ $t('privacy.section2CommunicationTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section2CommunicationText') }}</p>
          <h5>{{ $t('privacy.section2AntiCheatTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section2AntiCheatText') }}</p>
          <h5>{{ $t('privacy.section2TechnicalTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section2TechnicalText') }}</p>
          <h5>{{ $t('privacy.section2ThirdPartyTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section2ThirdPartyText') }}</p>

          <h4 id="privacy3">{{ $t('privacy.section3Title') }}</h4>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section3Intro') }}</p>
          <h5>{{ $t('privacy.section3ThirdPartyTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section3ThirdPartyText') }}</p>
          <h5>{{ $t('privacy.section3ProtectionTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section3ProtectionText') }}</p>
          <h5>{{ $t('privacy.section3MarketingTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section3MarketingText') }}</p>

          <h4 id="privacy4">{{ $t('privacy.section4Title') }}</h4>
          <h5>{{ $t('privacy.section4PromotionTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section4PromotionText') }}</p>
          <h5>{{ $t('privacy.section4ServiceNoticeTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section4ServiceNoticeText') }}</p>
          <h5>{{ $t('privacy.section4CustomerServiceTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section4CustomerServiceText') }}</p>
          <h5>{{ $t('privacy.section4ReferralTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section4ReferralText') }}</p>

          <h4 id="privacy5">{{ $t('privacy.section5Title') }}</h4>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section5Intro') }}</p>
          <h5>{{ $t('privacy.section5ProcessingTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section5ProcessingText') }}</p>
          <h5>{{ $t('privacy.section5PartnerTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section5PartnerText') }}</p>

          <h4 id="privacy6">{{ $t('privacy.section6Title') }}</h4>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section6Intro') }}</p>
          <h5>{{ $t('privacy.section6ControlTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section6ControlText') }}</p>
          <h5>{{ $t('privacy.section6ThirdPartyTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section6ThirdPartyText') }}</p>

          <h4 id="privacy7">{{ $t('privacy.section7Title') }}</h4>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section7Intro') }}</p>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section7SecurityText') }}</p>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section7RiskText') }}</p>

          <h4 id="privacy8">{{ $t('privacy.section8Title') }}</h4>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section8Intro') }}</p>
          <h5>{{ $t('privacy.section8DetailsTitle') }}</h5>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section8DetailsText') }}</p>
          <p class="privacy-answer">{{ formatServiceMessage('privacy.section8ContactText') }}</p>
        </div>
      </div>
    </section>
  </main>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';

const { t, locale } = useI18n();
const privacyBlockRef = ref<HTMLElement | null>(null);

const localeClass = computed(() => `is-${locale.value}`);

const formatServiceMessage = (key: string) => t(key).replace(/<br\s*\/?>(?:\r?\n)?/gi, '\n');

const scrollToTarget = (href: string) => {
  const targetId = href.replace('#', '');
  const targetEl = document.getElementById(targetId);

  if (targetEl) {
    targetEl.scrollIntoView({ behavior: 'smooth' });
  }
};

const handleParallaxScroll = () => {
  if (!privacyBlockRef.value) return;

  const scrolled = window.scrollY;
  const parallaxSpeed = 0.5;

  privacyBlockRef.value.style.backgroundPositionY = `${scrolled * parallaxSpeed}px`;
};

onMounted(() => {
  window.addEventListener('scroll', handleParallaxScroll, { passive: true });
  handleParallaxScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleParallaxScroll);
});
</script>

<style lang="scss" scoped>
@use '@/assets/css/main.scss' as *;

section {
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }
}

.privacy-block {
  height: 1200px;
  background: url(@/assets/img/privacyBanner.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-position-y: 0;
  background-color: $color-bg-dark02;
  position: relative;

  @media screen and (max-width: $breakpoint-xlarge) {
    height: auto;
    padding-top: 1000px;
  }

  @media screen and (max-width: $breakpoint-med) {
    padding-top: 700px;
  }

  @media screen and (max-width: $breakpoint-small) {
    padding-top: 600px;
  }

  @media screen and (max-width: $breakpoint-mini) {
    padding-top: 470px;
  }

  .text-wrap {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);

    @media screen and (max-width: $breakpoint-med) {
      width: 100%;
      bottom: 0;
    }
  }

  h1 {
    font-size: 40px;
    color: $color-white;
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;

    @media screen and (max-width: $breakpoint-med) {
      font-size: 30px;
    }

    @media screen and (max-width: $breakpoint-small) {
      font-size: 26px;
      margin-bottom: 20px;
    }
  }

  ul {
    width: 642px;
    background: url(@/assets/img/frame.png);
    padding: 50px 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 363px;

    @media screen and (max-width: $breakpoint-med) {
      width: 95%;
      height: auto;
      margin: 0 auto;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    @media screen and (max-width: $breakpoint-small) {
      padding: 20px 30px;
    }

    li {
      width: 300px;
      color: $color-white;
      line-height: 30px;

      a {
        transition: all 0.2s linear;

        &:hover {
          color: $color-primary;
        }
      }

      @media screen and (max-width: $breakpoint-mini) {
        width: 230px;
        font-size: 13px;
        line-height: 22px;
      }
    }
  }
}

.privacy-content {
  background-color: $color-bg-dark02;
  color: $color-white;
  line-height: 26px;
  font-size: 13px;

  .privacy-answer {
    white-space: pre-line;
  }

  h4 {
    font-size: 20px;
    font-weight: bold;
    color: $color-primary;
    margin-bottom: 20px;
  }

  h5 {
    font-size: 17px;
    border: 1px solid $color-primary;
    border-radius: 4px;
    width: fit-content;
    padding: 7px 6px;
    margin-bottom: 20px;
  }

  p {
    margin-bottom: 30px;
  }
}

.row-center {
  display: flex;
  justify-content: center;
}

.privacy-page.is-en,
.privacy-page.is-en * {
  letter-spacing: normal;
  @media screen and (max-width: $breakpoint-med) {
    .privacy-block ul {
      width: 80%;
      background-size: contain;
    }
  }
  .privacy-block ul li {
    width: 580px !important;
    @media only screen and (min-width: $breakpoint-small) {
      width: 100% !important;
    }
  }
}
</style>
